'use strict';
import InputMask from 'inputmask';

/**
* @description Handles quantity selector on PDP pages
*/
var quantitySelector = {
    eventHandlersAttached: false,

    /**
     * @function
     * @description - caches dom elements used as vars and returns an object
     */
    initCache: function() {
        const $quantityInput = $('.product-add-to-cart .js_quantity_input');

        var $cache = {
            quantityInput: $quantityInput,
            quantityIncrease: $('.js_quantity_increase'),
            quantityDecrease: $('.js_quantity_decrease'),
            minValue: 1,
            maxValue: ($quantityInput.length && $quantityInput.data('available'))
                ? Math.min(999, parseInt($quantityInput.data('available'), 10))
                : 5
        };

        return $cache;
    },

    /**
     * @function
     * @description - Increases quantity with 1
     */
    increaseQuantity: function(element) {
        element.val(parseInt(element.val(), 10) + 1);
        $(element).trigger('productQuantityIncreased');
    },

    /**
    * @function
    * @description - Decreases quantity with 1
    */
    decreaseQuantity: function(element) {
        element.val(parseInt(element.val(), 10) - 1);
        $(element).trigger('productQuantityDecreased');
    },

    /**
    * @function
    * @description - Checks input value in order to handle the max and min values allowed and to handle - and + controls state (enable/disable)
    */
    checkInputValue: function(element, minValue, maxValue) {
        var $cache            = this.initCache();
        var $quantityDecrease = element.parent().find('.js_quantity_decrease');
        var $quantityIncrease = element.parent().find('.js_quantity_increase');

        if (parseInt(element.val(), 10) <= $cache.minValue || !element.val() || !element.val().match(/^\d+$/)) {
            element.val($cache.minValue);
            $quantityDecrease.addClass('c-product__quantity--disabled');
        } else {
            $quantityDecrease.removeClass('c-product__quantity--disabled');
        }

        if (parseInt(element.val(), 10) >= $cache.maxValue) {
            element.val($cache.maxValue);
            $quantityIncrease.addClass('c-product__quantity--disabled');
        } else {
            $quantityIncrease.removeClass('c-product__quantity--disabled');
        }
    },

    /**
    * @function
    * @description - Handles events for the quantity selector
    */

    initEvents: function() {
        var $cache = this.initCache(),
            _that = this;

        this.checkInputValue($cache.quantityInput, $cache.minValue, $cache.maxValue);

        if (!this.eventHandlersAttached) {
            $(document).on('click', '.js_quantity_increase', function() {
                var $quantityInput = $(this).parent().find('.js_quantity_input');

                _that.increaseQuantity($quantityInput);
                _that.checkInputValue($quantityInput, $cache.minValue, $cache.maxValue);
            });

            $(document).on('click', '.js_quantity_decrease', function() {
                var $quantityInput = $(this).parent().find('.js_quantity_input');

                _that.decreaseQuantity($quantityInput);
                _that.checkInputValue($quantityInput, $cache.minValue, $cache.maxValue);
            });

            $(document).on('change', '.js_quantity_input', function() {
                var $quantityInput = $(this).parent().find('.js_quantity_input');

                _that.checkInputValue($quantityInput, $cache.minValue, $cache.maxValue);
            });

            this.eventHandlersAttached = true;
        }

        if ($cache.quantityInput.length) {
            InputMask('999', { placeholder: '' }).mask($cache.quantityInput.get(0));
        }
    },

    init: function() {
        this.initEvents();
    }
};

export default quantitySelector;
